import { useCallback, useState, useMemo, MutableRefObject, useEffect } from 'react';

import useResize from '../#useResize';

/**
 * From https://gist.github.com/morajabi/523d7a642d8c0a2f71fcfa0d8b3d2846/revisions
 */
const useRect = (ref: MutableRefObject<HTMLElement>, active = true) => {
  const [rect, setRect] = useState(() => getRect(ref ? ref.current : null));

  const handleResize = useCallback(() => {
    if (!ref.current) {
      return;
    }

    setRect(getRect(ref.current));
  }, [ref]);

  const options = useMemo(() => ({ active }), [active]);

  useResize(ref, handleResize, options);

  useEffect(() => {
    const element = ref?.current;
    element?.addEventListener('scroll', handleResize);
    return () => {
      element?.removeEventListener('scroll', handleResize);
    };
  });

  return rect;
};

function getRect(element: HTMLElement) {
  if (!element) {
    return {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0,
    };
  }

  return element.getBoundingClientRect();
}

export default useRect;
